import { Card, Divider, Grid, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { Link as NavLink } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { Role } from '../../../../recoil/atoms/user';
import {
  IPermissions,
  permissionsSelector,
} from '../../../../recoil/selectors/permissionsSelector';

const useStyles = makeStyles((theme: Theme) => ({
  averageContainer: {
    padding: '18px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  metricCard: {
    display: 'flex',
    flexDirection: 'row',
    padding: '8px',
    margin: '0px 48px 24px 48px',
    justifyContent: 'space-around',
  },
  averageRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'end',
    justifyContent: 'center',
    width: '130px',
  },
  agentTableContainer: {
    padding: '18px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
  card: {
    '& .MuiPaper-outlined': {
      border:
        theme.palette.mode === 'dark'
          ? '1px solid #005C78'
          : '1px solid #DAEFF8',
    },
  },
  boxShadow: {
    border: 0,
    boxShadow:
      '0 0 0 0.05rem rgb(8 60 130 / 10%), 0rem 0rem 1.25rem rgb(30 34 40 / 4%)',
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      background: theme.palette.mode === 'dark' ? '#353f43' : '#fbfbfb',
    },
    padding: '0 10px',
  },
}));

const AgentMetricTable = (props) => {
  const classes = useStyles();
  const { agentName, agentTotal, pectageOverAverage, agentid } = props;
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const { role } = permissionsLoadable.contents as IPermissions;
  const isUser = role === Role.USER;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        maxWidth: '250px',
      }}
      className={clsx(classes.tableRow)}
    >
      <div style={{ minWidth: '90px', textAlign: 'left' }}>
        {isUser && agentName}
        {!isUser && (
          <NavLink to={`/manage/agents/${agentid}/edit`}>{agentName}</NavLink>
        )}
      </div>
      <div style={{ minWidth: '70px', textAlign: 'center', fontWeight: 600 }}>
        {agentTotal}
      </div>
      <div style={{ minWidth: '70px', textAlign: 'right' }}>
        {pectageOverAverage}%
      </div>
    </div>
  );
};
const AgentMetricPanel = (props) => {
  const { metric } = props;
  const classes = useStyles();
  return (
    <Card variant="outlined" className={classes.boxShadow}>
      <Grid container spacing={2} direction="row" justifyContent="space-around">
        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <div className={classes.averageContainer}>
            <div
              style={{ textAlign: 'left', fontSize: '18px', fontWeight: 600 }}
            >
              {metric?.title}
            </div>
            <div className={classes.averageRow}>
              <div style={{ fontSize: '40px' }}>{metric?.average ?? 0}</div>
              <div style={{ marginBottom: '12px' }}>Average</div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <div className={classes.agentTableContainer}>
            {metric?.topAgents?.map((agent, i) => (
              <AgentMetricTable
                agentName={agent?.name}
                agentTotal={agent?.total}
                key={i}
                agentType={metric?.title === 'Missed Calls' ? 'bottom' : 'top'}
                pectageOverAverage={agent?.percent}
                agentid={agent?.agentid}
              />
            ))}
          </div>
        </Grid>
        <Divider orientation="vertical" flexItem />
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <div className={classes.agentTableContainer}>
            {metric?.bottomAgents?.map((agent, i) => (
              <AgentMetricTable
                agentName={agent?.name}
                agentTotal={agent?.total}
                key={i}
                agentType={metric?.title === 'Missed Calls' ? 'top' : 'bottom'}
                pectageOverAverage={agent?.percent}
                agentid={agent?.agentid}
              />
            ))}
          </div>
        </Grid>
      </Grid>
    </Card>
  );
};
export default AgentMetricPanel;
